import { render, staticRenderFns } from "./SmsManagementClient.vue?vue&type=template&id=458b1ea0&scoped=true&"
import script from "./SmsManagementClient.vue?vue&type=script&lang=js&"
export * from "./SmsManagementClient.vue?vue&type=script&lang=js&"
import style0 from "./SmsManagementClient.vue?vue&type=style&index=0&id=458b1ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b1ea0",
  null
  
)

export default component.exports